import { fmhNpiAPI, MED_BILLING_API_URL } from 'api/APIBase';
import {
    type ClaimFrequencyType,
    type ClaimPlaceOfServiceMap,
    type ClaimSubmissionType,
    type ClaimUomMap,
} from 'services/MedicalBillingConstants';

interface ClaimSubmission {
    payer_id: string;
    referral_id: string;
    claim_id: string;
    friendly_id?: string;
    transaction_id?: string;
    supplier_npi: string;
    place_of_service: keyof typeof ClaimPlaceOfServiceMap;
    member_id: string;
    patient_account_number: string;
    claim_frequency_type: ClaimFrequencyType;
    provider_signature_on_file: string;
    provider_accept_assignment: string;
    assignment_of_benefits: string;
    release_of_information: string;
    diagnoses: string[];
    submission_type: ClaimSubmissionType;
    taxonomy_code: string;
    original_claim_number?: string;
    services: {
        date_of_service: string;
        date_of_service_end: string;
        procedure_code: string;
        procedure_code_description: string;
        modifier_codes?: string[];
        ndc?: string;
        diagnoses: string[];
        dispensed_quantity?: number;
        dispensed_uom?: keyof typeof ClaimUomMap;
        billing_quantity: number;
        billing_uom: keyof typeof ClaimUomMap;
        provider_charge: number;
    }[];
}

/** Submits a claim/estimate */
export async function postClaim({
    npi,
    formattedClaim,
}: {
    npi: string;
    formattedClaim: ClaimSubmission;
}) {
    const url = `${MED_BILLING_API_URL}/${formattedClaim.payer_id}/claims`;
    return fmhNpiAPI({ url, npi }).post(formattedClaim).json<{ transaction_id: string }>();
}
